export const handleExternalUrl = (url) => {
    if (window.Android && window.Android.openUrl) {
        window.Android.openUrl(url);
    } else {
        window.open(url, '_system');
    }
};